import _ from 'lodash'

const summaryType = {
	VALUE: 'value',
	RANGE: 'range',
	DAY_OF_THE_WEEK: 'day-of-the-week',
	MONTH_OF_THE_YEAR: 'month-of-the-year',
	HOUR_OF_THE_DAY: 'hour-of-the-day',
	CALENDAR: 'calendar',
	SUM: 'sum',
	AVERAGE: 'average',
	CUSTOM: 'custom',
	MINIMUM: 'minimum',
	MAXIMUM: 'maximum',
	MIN_DATE: 'min-date',
	MIN_TIME: 'min-time',
	MAX_DATE: 'max-date',
	MAX_TIME: 'max-time',
	UNIQUE: 'unique',
	LIST_UNIQUE_VALUES: 'list-unique-values',
	STANDARD: 'standard',
	TREE: 'tree',
	LIST: 'list',
	GRANDCHILDREN: 'grandchildren',
	GREAT_GRANDCHILDREN: 'great-grandchildren',
	SIMILAR_TIME_RANGES: 'similar-time-ranges',
	CALENDAR_PERIOD: 'calendar-period',
	AUTOMATIC: 'automatic'
}

function isGroupSimilarTimeRanges(st) {
	return _.includes([summaryType.SIMILAR_TIME_RANGES,
		summaryType.DAY_OF_THE_WEEK, summaryType.MONTH_OF_THE_YEAR,
		summaryType.HOUR_OF_THE_DAY], st)
}

_.extend(summaryType, { isGroupSimilarTimeRanges })
export default summaryType
export { isGroupSimilarTimeRanges }
summaryType.__filename__ = 'datasets/model/summary-type.js'
